export const userMenu: object = {
  userMenu: {
    login: 'Login',
    logout: 'Log Out',
    account: 'Account Login',
    accountMenu: 'Account menu'
  }
};
